import { gql } from '@apollo/client'

const GET_STORIES_BULK = gql`
  query getStories($userId: Int, $nonprofitOrgId: Int) {
    getStories(userId: $userId, nonprofitOrgId: $nonprofitOrgId) {
      id
      templateUsed
      title
      hashedId
      publishedAt
      createdAt
      updatedAt
      archivedAt
      viewCount
      ctaClickCount
      hasClickTrackableBlock
      FunderOrgs {
        id
        name
      }
    }
  }
`

export default GET_STORIES_BULK
